import angular from 'angular';

import { MovimentacoesIndexController } from './index/movimentacoes.index.controller';

import { MovimentacoesService } from './movimentacoes.service';
import { MovimentacoesWorkflowService } from './movimentacoes-workflow.service';
import { MovimentacoesPeriodosService } from './movimentacoes-periodos.service';

import { MovimentacoesPeriodosModalController } from './index/modals/periodos/movimentacoes-periodos.modal.controller';
import { MovimentacoesPeriodosModalService } from './index/modals/periodos/movimentacoes-periodos.modal.service';

import { MovimentacoesPeriodoFormComponent } from './index/components/periodo-form/movimentacoes-periodo-form.component';
import { MovimentacoesPeriodoSelectorComponent } from './index/components/periodo-selector/movimentacoes-periodo-selector.component';
import { MovimentacoesDetalheDrawerComponent } from './index/components/detalhe-drawer/movimentacoes-detalhe-drawer.component';
import { MovimentacoesDetalheDrawerSummaryComponent } from './index/components/detalhe-drawer/summary/movimentacoes-detalhe-drawer-summary.component';
import { MovimentacoesListagemComponent } from './index/components/listagem/movimentacoes-listagem.component';
import { MovimentacoesMovimentacaoFormComponent } from './index/components/movimentacao-form/movimentacoes-movimentacao-form.component';
import { MovimentacoesQuickAddComponent } from './index/components/quick-add/movimentacoes-quick-add.component';

import { MovimentacoesListRouting } from './movimentacoes.routes';

export const MovimentacoesModule = angular.module('MovimentacoesModule', ['ui.router.state'])
    .controller('MovimentacoesIndexController', MovimentacoesIndexController)
    .controller('MovimentacoesPeriodosModalController', MovimentacoesPeriodosModalController)
    .component('movimentacoesDetalheDrawer', MovimentacoesDetalheDrawerComponent)
    .component('movimentacoesDetalheDrawerSummary', MovimentacoesDetalheDrawerSummaryComponent)
    .component('movimentacoesListagem', MovimentacoesListagemComponent)
    .component('movimentacoesMovimentacaoForm', MovimentacoesMovimentacaoFormComponent)
    .component('movimentacoesPeriodoForm', MovimentacoesPeriodoFormComponent)
    .component('movimentacoesPeriodoSelector', MovimentacoesPeriodoSelectorComponent)
    .component('movimentacoesQuickAdd', MovimentacoesQuickAddComponent)
    .service('MovimentacoesService', MovimentacoesService)
    .service('MovimentacoesWorkflowService', MovimentacoesWorkflowService)
    .service('MovimentacoesPeriodosService', MovimentacoesPeriodosService)
    .service('MovimentacoesPeriodosModalService', MovimentacoesPeriodosModalService)
    .config(MovimentacoesListRouting)
    .name;
